export default {"src":"/_next/static/media/assistance.c9744748.svg","height":50,"width":50};